"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CartConfiguration_1 = require("./CartConfiguration");
exports.default = CartConfiguration_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartConfigurationContainer/index.js
// module id = 796
// module chunks = 8